export default __webpack_public_path__ + "static/media/for-customer.1fa12488.mp4";